import { useEffect, useState } from 'react';

export const useClassNameWithLoading = (className: string) => {
  const loadingClass = `${className}-loading`;
  const [classNames, setClassNames] = useState([className, loadingClass]);

  useEffect(() => {
    requestAnimationFrame(() =>
      setClassNames(state => state.filter(c => c !== loadingClass))
    );
  }, [loadingClass]);

  return classNames;
}
